import React, { useState } from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Modal, Typography } from '@crisellevaldez/speculo-ui';
import type { Contact } from '../../../../types/contact.types';
import { ContactSidePanel } from './ContactSidePanel';

interface CurrentStatusSummaryProps {
  contact: Contact | null;
}

export const CurrentStatusSummary: React.FC<CurrentStatusSummaryProps> = ({ contact }) => {
  const [notesOpen, setNotesOpen] = useState(false);
  if (!contact) return null;

  // Hide unless Remi produced a summary; never synthesise one client-side.
  const narrative = contact.aiIntelligence?.summary?.trim();
  if (!narrative) return null;

  return (
    <>
      <div className="relative rounded-xl ring-1 shadow-md p-3 sm:p-3.5 bg-amber-50 dark:bg-amber-500/10 ring-amber-200 dark:ring-amber-500/30">
        <div className="flex items-center justify-between gap-2 mb-1.5">
          <span className="text-[10px] font-semibold uppercase tracking-wider text-foreground/70">
            Contact summary
          </span>
          <button
            type="button"
            onClick={() => setNotesOpen(true)}
            className="inline-flex items-center gap-0.5 text-[11px] font-medium text-amber-800 hover:text-amber-900 dark:text-amber-300 dark:hover:text-amber-200 underline underline-offset-2 decoration-amber-400/60 hover:decoration-amber-500 transition-colors flex-shrink-0 group"
          >
            Remi's notes
            <ArrowRight className="w-3 h-3 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
        <p className="text-[12.5px] sm:text-[13px] xl:text-sm text-foreground/85 leading-relaxed">
          {narrative}
        </p>
      </div>

      <Modal isOpen={notesOpen} onClose={() => setNotesOpen(false)} size="lg">
        <Modal.Header>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400">
              <Sparkles className="w-3.5 h-3.5" />
            </span>
            <Typography variant="h3" className="font-semibold">
              Remi's notes
            </Typography>
          </div>
        </Modal.Header>
        <Modal.Body>
          <ContactSidePanel contact={contact} />
        </Modal.Body>
      </Modal>
    </>
  );
};
